import { NgTemplateOutlet } from '@angular/common'
import { booleanAttribute, Component, computed, effect, input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { HtmlAttributesDirective } from 'src/app/shared/directives/html-attributes.directive'
import { NavAttributes, NavLinkProps } from '../breadcrumb-item.interface'

@Component({
    selector: 'sf-breadcrumb-item',
    templateUrl: './breadcrumb-item.component.html',
    styleUrl: './breadcrumb-item.component.scss',
    imports: [RouterModule, NgTemplateOutlet, HtmlAttributesDirective],
    exportAs: 'breadcrumbItem',
    host: {
        '[attr.aria-current]': 'ariaCurrent()',
        '[class]': 'hostClasses()',
    },
})
export class BreadcrumbItemComponent {
    /**
     * Toggle the active state for the component. [docs]
     * @return boolean
     */
    readonly active = input<boolean, unknown>(undefined, { transform: booleanAttribute })

    /**
     * The `url` prop for the inner `[routerLink]` directive. [docs]
     * @return string
     */
    readonly url = input<string | any[]>()

    /**
     * Additional html attributes for link. [docs]
     * @return INavAttributes
     */
    readonly attribs = input<NavAttributes>()
    protected readonly _attributes = input<NavAttributes>(undefined, { alias: 'attributes' })

    readonly #attributesEffect = effect(() => {
        if (this._attributes()) {
            console.error('c-breadcrumb-item: [attributes] prop is removed, use [attribs] instead:', this._attributes())
        }
    })

    /**
     * Some `NavigationExtras` props for the inner `[routerLink]` directive and `routerLinkActiveOptions`. [docs]
     * @return INavLinkProps
     */
    readonly linkProps = input<NavLinkProps>()

    readonly ariaCurrent = computed((): string | null => {
        return this.active() ? 'page' : null
    })

    readonly hostClasses = computed(() => {
        return {
            'breadcrumb-item': true,
            active: this.active(),
        } as Record<string, boolean>
    })
}
